import CardDesignerCardElementResizeControls from './CardDesignerCardElementResizeControls';

export default CardDesignerCardElementResizeControls;
